import { parse, isBefore, isAfter } from 'date-fns';
// import isAfter from 'date-fns/is_after';

const createStoreName = ({ title }) => title.toLowerCase().replace(/\s/, '-');

export const createSchema = ({ wpHeadings }) =>
  wpHeadings
    .map(wpHeading => ({ store: createStoreName(wpHeading) }))
    .concat({
      store: 'all',
    });

export const getCurrentStore = ({ wpHeadings }) => {
  const current = wpHeadings.find(wph => wph.current);
  return current ? createStoreName(current) : 'all';
};

export const processSessions = sessions =>
  sessions
    .map(session => {
      return ({
      ...session,
      start: parse(session.start),
      // startStr: session.start,
      finish: parse(session.finish),
      // finishStr: session.finish,
    })
    })
    .sort(({ start: startA }, { start: startB }) => {
      if (isBefore(startA, startB)) return -1;
      if (isAfter(startA, startB)) return 1;
      return 0;
    });
